<template>
  <div class="intersection-observer">
    <slot />
    <div ref="observerTarget" class="observer-target"></div>
  </div>
</template>
<script setup>
  import { onMounted, onUnmounted, ref, defineEmits } from 'vue'
  const observerTarget = ref(null)
  const emit = defineEmits(['observer-in', 'observer-out'])
  let observer = null

  const handleIn = () => {
    emit('observer-in')
  }

  const handleOut = () => {
    emit('observer-out')
  }

  const createObserver = (element) => {
    observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          handleIn()
        } else {
          handleOut()
        }
      },
      {
        root: null,
        threshold: 0,
      },
    )

    observer.observe(element)
  }

  onMounted(() => {
    if (observerTarget.value) {
      createObserver(observerTarget.value)
    }
  })

  onUnmounted(() => {
    observer.disconnect()
    observer = null
  })
</script>
